import { render, staticRenderFns } from "./DonutChart05.vue?vue&type=template&id=0e08bbe2&scoped=true"
import script from "./DonutChart05.vue?vue&type=script&lang=js"
export * from "./DonutChart05.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e08bbe2",
  null
  
)

export default component.exports